import React, { useEffect, useReducer, useState } from 'react';
import {
  Button, Grid, Table, Radio,TableCell, TableHead, TableRow, CircularProgress, Switch,
  Dialog, DialogContent, DialogTitle, DialogActions, DialogContentText, Modal, IconButton
} from '@material-ui/core';
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import { client } from '../../config/apollo';
import { GET_SUBSCRIPTION_PLANS, VALIDATE_COUPON, FETCH_SUBSCRIPTION_PRORATION_DETAILS, FETCH_SUBSCRIPTION_LIST } from "../../graphql/queries/chef";
import { CREATE_SUBSCRIPTION, CANCEL_SUBSCRIPTION, CHANGE_SUBSCRIPTION } from "../../graphql/mutations/chef";
import { getPaymentInfo } from "../../redux/user";
import moment from "moment";
import style from './style';
import styles from "../Transactions/styles";
import {Cancel} from "@material-ui/icons";
import AddCard from '../AddCard';

const amex = "/images/amex.webp";
const discover = "/images/discover.webp";
const dinersclub = "/images/dinersclub.webp";
const jcb = "/images/jcb.webp";
const mastercard = "/images/mastercard.webp";
const visa = "/images/visa.webp";
const unionpay = "/images/unionpay.png";
const othercc = "/images/cc-outline.png";

const headCells = [
  {
    id: 'tdate',
    numeric: false,
    disablePadding: true,
    label: 'Billing Date',
  },
  {
    id: 'planName',
    numeric: false,
    disablePadding: true,
    label: 'Plan Name',
  },
  {
    id: 'duration',
    numeric: false,
    disablePadding: true,
    label: 'Duration',
  },
  {
    id: 'amount',
    numeric: true,
    disablePadding: true,
    label: 'Amount',
  },
  {
    id: 'active',
    numeric: false,
    disablePadding: true,
    label: 'Status',
  }
];

const SubscriptionPage = (props) => {
  const now = moment();
  const [subscriptions, setSubscriptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [lastSubscription, setLastSubscription] = useState(null);
  const [showPlans, setShowPlans] = useState(false);
  const [plansList, setPlansList] = useState([]);
  const [isAnnually, setIsAnnually] = useState(true);
  const [selectedPlan, setSelectedPlan] = useState('Pro');
  const [showCard, setShowCard] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [showAddCard, setShowAddCard] = useState(false);
  const [lastSubscriptionPassed, setLastSubscriptionPassed] = useState(now.unix());


  const fetchSubscriptions = () => {
    setIsLoading(true);
    client.query({
      query: FETCH_SUBSCRIPTION_LIST,
      variables: {
        chefId: props.userId
      },
      fetchPolicy: 'network-only'
    }).then(response => {
        if (!!response && !!response.data && !!response.data.fetchSubscriptionList) {
          const subscriptionData = response.data.fetchSubscriptionList;
          setSubscriptions(subscriptionData);
          const subscriptionDataLen = subscriptionData.length;

          if (subscriptionDataLen && subscriptionDataLen > 0) {
            const listLastSubs = subscriptionData[subscriptionDataLen - 1];
            setLastSubscription(listLastSubs);
            // if (listLastSubs.isCancelled) {
              const endDate = moment(listLastSubs.startedOn).add(listLastSubs.duration, listLastSubs.durationType);
              setLastSubscriptionPassed(endDate.unix())
             // } // end-if last subscription is cancelled
          }
        }

        setIsLoading(false);
      })
      .catch(err => {setIsLoading(false);});
  };

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  useEffect(() => {
    if (!props.userId) return;

    client.query({
        query: GET_SUBSCRIPTION_PLANS,
        fetchPolicy: "network-only",
        variables: { userId: props.userId }
      })
      .then(response => {
        if (!!response && !!response.data && !!response.data.productsList) {
          setPlansList(response.data.productsList);
          // this.handlePlanChange('pro');
        }
      })
      .catch(err => console.error('ERROR Fetching products: ', err));

    props.dispatch(getPaymentInfo(props.userId));
  }, [props.userId]);

  useEffect(() => {
    if (lastSubscription && lastSubscription.cardId) {
      const cardId = lastSubscription.cardId;
      if (!!props.paymentInfo && props.paymentInfo.length) {
        const card = props.paymentInfo.find(item => item.card.cardId === cardId);
        if (card) setSelectedCard(card);
      }

    } else if (!!props.paymentInfo && props.paymentInfo.length) {
      const lastCard = props.paymentInfo[props.paymentInfo.length - 1];
      if (lastCard.card) {
        setSelectedCard(lastCard.card);
      }
    }
  },[lastSubscription, props.paymentInfo])

  const cancelSubscription = () => {
    if (!subscriptions.length) {
      setShowDialog(false)
      return;
    };

    setIsLoading(true);

    client.mutate({
      mutation: CANCEL_SUBSCRIPTION,
      variables: {
        id: props.userId,
        subscriptionId: lastSubscription.subscriptionId
      }
    })
      .then(response => {
        setIsLoading(false);
        setShowDialog(false);
        fetchSubscriptions();
        NotificationManager.info('Your subscription has been successfully canceled.', 'Subscription', 3500);
      })
      .catch(err => {
        setIsLoading(false);
        setShowDialog(false);
        NotificationManager.error('There was some error cancelling your subscription. Please try after sometime.', 'Subscription', 5000);
      });
  };

  const closePlans = () => { setShowPlans(false) };
  const closeAddCard = () => { setShowAddCard(false) };

  const addNewCard = () => {
    setShowAddCard(false);
  };

  const newSubscription = (priceId) => {
    setIsLoading(true);
    client.mutate({
        mutation: CREATE_SUBSCRIPTION,
        variables: {
          id: props.userId,
          cardId: selectedCard.cardId,
          priceId: priceId,
        }
      })
      .then(response => {
        fetchSubscriptions(); setIsLoading(false);
        NotificationManager.info('Successfully subscribed to new plan.', 'Subscription');
      })
      .catch(err => {
        console.error('ERROR creating subscription plan', err)
        let errorObj = JSON.parse(JSON.stringify(err));
        if (errorObj.graphQLErrors) {
          errorObj.graphQLErrors.forEach(er => {
            NotificationManager.error(er.message, 'Subscription');
          })
        }
        setIsLoading(false);
      });
    setShowCard(false);
    setShowAddCard(false);
    setSelectedCard(null);
    setShowPlans(false);
  };

  const changePlan = () => {
    setIsLoading(true);
    /*if (!selectedCard) {
      setIsLoading(false);
      NotificationManager.error('Default card is not selected.', 'Subscription');
      return;
    }*/

    if (!selectedPlan) {
      setIsLoading(false);
      NotificationManager.error('Select a plan to change.', 'Subscription');
      return;
    }

    let plan = null;

    plansList.forEach(planItem => {
      if (planItem.name.startsWith(selectedPlan)) {
        plan = planItem;
      }
    });

    const priceId = isAnnually ?
      plan.priceScheme.find(priceItem => priceItem.recurring.interval === 'year').id :
      plan.priceScheme.find(priceItem => priceItem.recurring.interval !== 'year').id;

    const planPrice = isAnnually ?
      plan.priceScheme.find(priceItem => priceItem.recurring.interval === 'year').unit_amount :
      plan.priceScheme.find(priceItem => priceItem.recurring.interval !== 'year').unit_amount;

    if (plan.name === lastSubscription.name && planPrice/100 === lastSubscription.price && !lastSubscription.isCancelled && !lastSubscription.didFailed) {
      setIsLoading(false);
      NotificationManager.error('New plan cannot be same as old.', 'Subscription');
      return;
    }

    // check if a new subscription or change subscription
    if (subscriptions.length) {
      if (!lastSubscription) {
        setIsLoading(false);
        newSubscription(priceId);
        return;
      }

      if (lastSubscription.didFailed) {
        setIsLoading(false);
        newSubscription(priceId);
        return;
      }

      client.mutate({
          mutation: CHANGE_SUBSCRIPTION,
          variables: {
            id: props.userId,
            cardId: selectedCard.cardId,
            subscriptionId: lastSubscription.subscriptionId,
            priceId,
          }
        })
        .then(response => {
          fetchSubscriptions(); setIsLoading(false);
          NotificationManager.info('Successfully subscribed to new plan.', 'Subscription');
        })
        .catch(err => {
          console.error('ERROR changing subscription plan ', err);
          setIsLoading(false);
          let errorObj = JSON.parse(JSON.stringify(err));
          if (errorObj.graphQLErrors) {
            errorObj.graphQLErrors.forEach(er => {
              NotificationManager.error(er.message, 'Subscription');
            })
          }
        });
    } else newSubscription(priceId);

    setShowCard(false);
    setShowAddCard(false);
    setSelectedCard(null);
    setShowPlans(false);
  };

  const checkExpired = subscription => {
    const now = moment();
    if (!subscription.duration || !subscription.durationType) return false;

    const endDate = moment(new Date(subscription.startedOn)).add(subscription.duration, subscription.durationType);

    if (endDate.isSameOrBefore(now)) return true;

    return false;
  };

  return (
    <>
      <div>
        <p style={style.headerText}>Subscriptions</p>
        <Grid container alignItems={"flex-end"} justify={"flex-end"}>
          {!!lastSubscription && !lastSubscription.isCancelled && !lastSubscription.didFailed && !lastSubscription.isScheduled && lastSubscriptionPassed > now.unix() ? <Button
            onClick=
              {() => setShowDialog(true)}
            style={style.subscribeButton}
            disabled={isLoading}
            data-test-id={"btn-subscription-cancel"}
          >
              Cancel subscription
          </Button> : lastSubscription && !lastSubscription.didFailed && !lastSubscription.isScheduled && lastSubscription.isCancelled ? (<p>
            Your <span style={{ color: '#ff8000' }}>
            {lastSubscription.name}
          </span> is active through {moment.unix(lastSubscription.startedOn/1000).add(lastSubscription.duration, lastSubscription.durationType).format('MM/DD/YYYY')}.
            Contact <a href="mailto:support@cuisinecrafters.net" style={{
            color: '#ff8000',
            textDecoration: 'none',
            cursor: 'pointer'
          }}>support@cuisinecrafters.net</a> if you have any questions.
          </p>) : <></>}
        </Grid>

        <Grid container>
          <Grid className="transition-table-row" item xs={12} style={{marginTop: 30}}>
            {isLoading ? <CircularProgress /> : <Table size={'medium'} className="transition-table">
              <TableHead>
                <TableRow>
                  {headCells.map(headCell => (
                    <TableCell
                      key={headCell.id}
                      align={headCell.numeric ? 'center' : 'left'}
                      padding={'default'}
                    >
                      <span style={styles.tableHead}>{headCell.label}</span>
                    </TableCell>
                  ))}
                </TableRow>
                {subscriptions.length === 0 && <TableRow>
                  <TableCell align={'center'} colSpan={4}>
                    <span style={styles.tableCell}>No Records Found</span>
                  </TableCell>
                </TableRow>}
                {subscriptions.map(sub => (
                  sub.didFailed ? (<TableRow>
                      <TableCell>{moment.unix(sub.failedAt/1000).format("MM/DD/YY")}</TableCell>
                      <TableCell>{sub.name}</TableCell>
                      <TableCell>{sub.duration} {sub.durationType}</TableCell>
                      <TableCell align="center"  style={{ minWidth: 100, paddingRight: 25 }}>
                      <span style={styles.tableCellAmount}>
                        $ {sub.price}
                      </span>
                      </TableCell>
                      <TableCell style={{ color: "red" }}>
                        Failed
                      </TableCell>
                    </TableRow>) :
                  <>
                    <TableRow>
                      <TableCell>{moment.unix(sub.isScheduled ? sub.scheduleDate/1000 : sub.startedOn/1000).format("MM/DD/YY")}</TableCell>
                      <TableCell>{sub.name}</TableCell>
                      <TableCell>{sub.duration} {sub.durationType}</TableCell>
                      <TableCell align="center"  style={{ minWidth: 100, paddingRight: 25 }}>
                        <span style={styles.tableCellAmount}>
                          $ {sub.price}
                        </span>
                      </TableCell>
                      <TableCell style={{ color: sub.isScheduled ? "#ff8000" : checkExpired(sub) ? "red" : "green" }}>
                        {!sub.isScheduled ? checkExpired(sub) ? 'Expired' : 'Active' : 'Scheduled'}
                      </TableCell>
                    </TableRow>
                    {sub.isCancelled && <TableRow>
                      <TableCell>{moment.unix(sub.cancelledAt/1000).format("MM/DD/YY")}</TableCell>
                      <TableCell>{sub.name}</TableCell>
                      <TableCell>{sub.duration} {sub.durationType}</TableCell>
                      <TableCell align="center"  style={{ minWidth: 100, paddingRight: 25 }}>
                      <span style={styles.tableCellAmount}>
                        $ {sub.price}
                      </span>
                      </TableCell>
                      <TableCell style={{ color: "red" }}>
                        Canceled
                      </TableCell>
                    </TableRow>}
                  </>
                ))}
              </TableHead>

            </Table>}
            <div className="change-subscription-button-wrapper">
              <Button
                style={isLoading ? style.cancelButton : style.subscribeButton}
                disabled={isLoading}
                data-test-id={"btn-subscription-change-purchase"}
                onClick={() => {
                  setShowPlans(true);
                  setShowAddCard(false);
                  setShowCard(false);
                  /*if (subscriptions.length && !lastSubscription.isCancelled && !lastSubscription.didFailed) {
                    fetchProrationDetails()
                  }*/
                }}>
                {isLoading ? <CircularProgress />
                  : subscriptions.length && !lastSubscription.isCancelled && !lastSubscription.didFailed ? 'Change Plan' : 'Renew Plan'}
              </Button>
            </div>

          </Grid>
        </Grid>
        {showDialog && <Dialog
          open={showDialog}
          onClose={() => setShowDialog(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle>Cancel Subscription</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to cancel the subscription ?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={cancelSubscription} data-test-id={"btn-subscription-cancel-yes"}>Yes</Button>
            <Button onClick={() => setShowDialog(false)} data-test-id={"btn-subscription-cancel-no"}>No</Button>
          </DialogActions>
        </Dialog>}
        <Modal
          open={showPlans}
          onClose={closePlans}
        >
          <>
            {showCard && props.paymentInfo ? (<div className="show-plans-wrapper show-card-modal-wrapper">
              <div className="cards-list-wrapper">
                <div className="cards-list-wrapper-header">
                  <h3>Choose a card</h3>
                  <div className="show-plans-header-close">
                    <IconButton onClick={closePlans} data-test-id={"btn-subscription-close-select-card-modal"}>
                      <Cancel style={{fontSize: 32}} />
                    </IconButton>
                  </div>
                </div>
                <div className="cards-list-container">
              {props.paymentInfo.map((payment, index) => (
                <div className="card-wrapper" key={`card-${index}`}>
                  <div>
                    <Radio
                      checked={selectedCard === payment.card.cardId}
                      data-test-id={"btn-subscription-choose-card-radio"}
                      onChange={() => {
                        if (selectedCard !== payment.card.cardId) {
                          setSelectedCard(payment.card.cardId)
                        }
                      }}
                    />
                  </div>
                  <div><span>
                    {payment.card.type.toLowerCase().startsWith('american') || payment.card.type.toLowerCase().startsWith('amex') ?
                      'XXXX-XXXXXX-X' : 'XXXX-XXXX-XXXX-'}
                    {payment.card.last4}
                  </span></div>
                  <div>
                    {payment.card.type !== '' && <img
                      src={payment.card.type.toLowerCase().startsWith('visa') ? visa : (
                        payment.card.type.toLowerCase().startsWith('master') ? mastercard : (
                          payment.card.type.toLowerCase().startsWith('american') || payment.card.type.toLowerCase().startsWith('amex') ? amex : (
                            payment.card.type.toLowerCase().startsWith('disco') ? discover : (
                              payment.card.type.toLowerCase().startsWith('diner') ? dinersclub : (
                                payment.card.type.toLowerCase().startsWith('jc') ? jcb : unionpay
                              )
                            )
                          )
                        )
                      )}
                      style={{
                        marginTop: 0,
                        minHeight: 20,
                        maxHeight: 60,
                        minWidth: 61,
                        maxWidth: 120
                      }}
                    />}
                  </div>
                </div>
              ))}
                </div>

              <div className="subscription-card-buttons-wrapper">
                <Button
                  style={style.cancelButton}
                  data-test-id={"btn-subscription-back-choose-card"}
                  onClick={() => {
                  setShowAddCard(false);
                  setShowPlans(true);
                  setShowCard(false);
                }}>
                  Back
                </Button>
                <Button style={style.subscribeButton} onClick={() => setShowAddCard(true)} data-test-id={"btn-subscription-show-add-card-modal"}>
                  Add card
                </Button>

                {selectedCard && <Button style={style.purchaseButton} onClick={changePlan} data-test-id={"btn-subscription-purchase-from-choose-card"}>
                  Purchase
                </Button>}
              </div>
            </div></div>) : (
              <div className="show-plans-wrapper">
                <div className="show-plans-header">
                  <h4>Subscription Plans</h4>
                  <div className="show-plans-header-close">
                    <IconButton onClick={closePlans} data-test-id={"btn-subscription-show-plans-close"}>
                      <Cancel style={{ fontSize: 32 }} />
                    </IconButton>
                  </div>
                </div>

                <div className="plan-selection-interval">
                  <Switch
                    data-test-id={"btn-subscription-switch-monthly-annually"}
                    checked={isAnnually} onChange={(ev) => {
                    setIsAnnually(!isAnnually);
                  } } />
                  <span >{!isAnnually ? 'Monthly' : 'Annual'}</span>
                </div>

                <div className="show-plans-container">
                  <div className="plan-item-wrapper">
                    {plansList.length && plansList.map((planItem, index) => (
                      <div className={`plan-item ${planItem.name.startsWith(selectedPlan) ? '' : 'selected-plan'}`}>
                        <div
                          data-test-id={`btn-subscription-select-plan-titles-${index}`}
                          onClick={() => setSelectedPlan(selectedPlan === 'Pro' ? 'Flex' : 'Pro')}
                          className={`plan-item-name ${planItem.name.startsWith(selectedPlan) ? '' : 'selected-plan'}`}>
                          {planItem.name}
                        </div>
                        {planItem.description && <div className={`plan-item.description ${planItem.name.startsWith(selectedPlan) ? '' : 'selected-plan'}`}>{planItem.description}</div>}
                        <div className={`plan-item-fee ${planItem.name.startsWith(selectedPlan) ? '' : 'selected-plan'}`}>
                          <div className={`plan-item-fee-header ${planItem.name.startsWith(selectedPlan) ? '' : 'selected-plan'}`}>Listing fee</div>
                          <div className={`plan-item-fee-amount ${planItem.name.startsWith(selectedPlan) ? '' : 'selected-plan'}`}>
                            $ {isAnnually && planItem && planItem.priceScheme ?
                            (planItem.priceScheme.find(priceItem => priceItem.recurring.interval === 'year').unit_amount / 100) :
                            (planItem.priceScheme.find(priceItem => priceItem.recurring.interval === 'month').unit_amount / 100)}
                          </div>
                        </div>
                        <div className={`price-item-verified-chef ${planItem.name.startsWith(selectedPlan) ? '' : 'selected-plan'}`}>
                          Verified chef<br />
                          <span>{planItem.name.startsWith('Pro') ? 'Included' : 'Not included'}</span>
                          <span className={`price-item-verified-chef-price ${planItem.name.startsWith(selectedPlan) ? '' : 'selected-plan'}`}>($50 {planItem.name.startsWith('Pro') ? 'savings' : 'extra'})</span>
                        </div>
                        <div className={`price-item-transaction-fee ${planItem.name.startsWith(selectedPlan) ? '' : 'selected-plan'}`}>
                          Transaction fee<br />
                          <span>{planItem.name.startsWith('Pro') ? '5' : '15'}% of the booking value</span>
                        </div>
                        <div className={`price-item-featured-chef ${planItem.name.startsWith(selectedPlan) ? '' : 'selected-plan'}`}>
                          Featured chef<br />
                          <span>{planItem.name.startsWith('Pro') ? 'More' : 'Less'} often</span>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="selected-plan-details">
                    <div className="selected-plan-footnote">
                      New plan: {selectedPlan} plan <span>(Interval: {isAnnually ? 'Annually' : 'Monthly'})</span>
                    </div>

                    <Button
                      style={style.cancelButton}
                      data-test-id={"btn-subscription-cancel-select-plan-modal"}
                      onClick={() => {
                        setShowCard(false);
                        setShowDialog(false);
                        setShowPlans(false);
                      }}
                    >Cancel</Button>

                    <Button
                      style={style.subscribeButton}
                      data-test-id={"btn-subscription-apply-new-plan"}
                      onClick={() => {
                        setShowCard(false);
                        setShowDialog(false);
                        changePlan()
                      }}
                    >Apply</Button>

                  </div>
                </div>
              </div>
            )}
          </>
        </Modal>

        <AddCard show={showAddCard} close={closeAddCard} onSuccess={addNewCard} />
      </div>
    </>
  );
};

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    diner: state.user.diner,
    chef: state.user.chef,
    paymentInfo: state.user.paymentInfo
  };
};

export default connect(mapStateToProps)(SubscriptionPage);
